import jsPDF from 'jspdf';
import JsBarcode from 'jsbarcode';

/**
 * Generates PDF labels for verified items with barcodes
 * @param {Array} items - Array of items to generate labels for
 * @param {string} filename - Optional filename for the PDF (defaults to using first item.id)
 * @param {Array} pageSize - Optional page size in points [width, height] (defaults to 3"x2" labels)
 */
export const generateItemLabels = async (items, filename, pageSize = [ 216, 144 ]) => {
    // 3"x2" labels = 216x144 points (72 points per inch)
    const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'pt',
        format: pageSize
    });
    let y = 20;

    // Generate filename if not provided
    if (!filename && items.length > 0) {
        if (items.length === 1) {
            filename = `${ items[ 0 ].id }_label.pdf`;
        } else {
            filename = `verified_labels_${ items.length }_items.pdf`;
        }
    } else if (!filename) {
        filename = 'verified_items_labels.pdf';
    }

    for (const item of items) {
        // Reset Y position for each label (since each item gets its own page for labels)
        y = 10;

        doc.setFontSize(10); // Increased font size for better readability

        doc.text(`Name: ${ item.name || 'N/A' }`, 5, y);
        doc.text(`Brand: ${ item.brand || 'N/A' }`, 5, y + 11);
        doc.text(`Desc: ${ item.desc || 'N/A' }`, 5, y + 22);
        doc.text(`Size: ${ item.size || 'N/A' }`, 5, y + 33);
        doc.text(`Gender: ${ item.gender || 'N/A' }`, 5, y + 44);
        doc.text(`Color: ${ item.color || 'N/A' }`, 5, y + 55);

        doc.setLineWidth(1.5);

        // price box
        doc.line(100, y + 26, 100, y + 60); // Vertical line (left)
        doc.line(99.5, y + 26, pageSize[ 0 ], y + 26); // Horizontal line (top)

        // Price text
        doc.setFontSize(25);
        doc.text(`$${ item.price.toFixed(2) || 'N/A' }`, 105, y + 52);

        // separator line
        doc.line(0, y + 60, pageSize[ 0 ], y + 60);

        // Generate barcode - higher resolution for better quality
        const barcodeValue = item.barcode || item.id;
        const canvas = document.createElement('canvas');
        
        canvas.width = 400; // Higher resolution canvas
        canvas.height = 120;

        JsBarcode(canvas, barcodeValue, {
            format: 'CODE128',
            width: 2, // Thicker bars for better printing
            height: 60, // Taller barcode
            fontSize: 18, // Larger text under barcode
            margin: 5
        });

        const imgData = canvas.toDataURL('image/png');

        // Position barcode to fit within label bounds - adjusted size and position
        doc.addImage(imgData, 'PNG', 10, y + 70, 180, 60);

        // Add new page for next label if there are more items
        if (items.indexOf(item) < items.length - 1) {
            doc.addPage();
        }
    }

    doc.save(filename);
};